module.exports = __webpack_public_path__ + "static/media/alert.c76b1e0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alert.mp3
// module id = 2Z/k
// module chunks = 1